
import React from 'react';
import { Zap, Calendar } from 'lucide-react';
import { Card } from '@/components/ui/card';

const Step1MergeType = ({ wizardData, updateWizardData }) => {
  const mergeTypes = [
    {
      id: 'instant',
      title: 'Instant Merge',
      description: 'Immediate emergency merge for unexpected situations like vehicle breakdown',
      icon: Zap,
      color: 'orange',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      borderColor: 'border-orange-300',
      hoverBg: 'hover:bg-orange-50',
      selectedBorder: 'border-orange-600',
    },
    {
      id: 'scheduled',
      title: 'Scheduled Merge',
      description: 'Plan ahead for maintenance, events, or anticipated changes',
      icon: Calendar,
      color: 'blue',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      borderColor: 'border-blue-300',
      hoverBg: 'hover:bg-blue-50',
      selectedBorder: 'border-blue-600',
    },
  ];

  const handleSelect = (typeId) => {
    updateWizardData('mergeType', typeId);
  };

  return (
    <div className="space-y-6">
      <p className="text-gray-600">
        Choose the type of merge based on your situation. Instant merges take effect immediately,
        while scheduled merges allow you to plan for a specific date and time.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {mergeTypes.map((type) => {
          const Icon = type.icon;
          const isSelected = wizardData.mergeType === type.id;

          return (
            <Card
              key={type.id}
              onClick={() => handleSelect(type.id)}
              className={`p-6 cursor-pointer transition-all ${
                isSelected
                  ? `border-2 ${type.selectedBorder} bg-${type.color}-50`
                  : `border-2 border-gray-200 ${type.hoverBg}`
              }`}
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div
                  className={`w-16 h-16 rounded-full ${type.iconBg} flex items-center justify-center`}
                >
                  <Icon className={`h-8 w-8 ${type.iconColor}`} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{type.title}</h3>
                  <p className="text-sm text-gray-600">{type.description}</p>
                </div>
                {isSelected && (
                  <div className={`flex items-center gap-2 text-sm font-medium ${type.iconColor}`}>
                    <div className="w-2 h-2 rounded-full bg-current"></div>
                    Selected
                  </div>
                )}
              </div>
            </Card>
          );
        })}
      </div>

      {wizardData.mergeType && (
        <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Note:</strong>{' '}
            {wizardData.mergeType === 'instant'
              ? 'Instant merge will combine buses immediately. Students and parents will be notified right away.'
              : 'Scheduled merge allows you to plan the merge for a specific date. All stakeholders will be notified in advance.'}
          </p>
        </div>
      )}
    </div>
  );
};

export default Step1MergeType;
